import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { GRID_BREAKPOINTS } from '@/config/grid-breakpoints';

const AssistantLoadingSkeleton: React.FC = () => {
  return (
    <div className={`grid ${GRID_BREAKPOINTS.imageCards} gap-6`}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="flex flex-col rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700">
          <Skeleton className="w-full h-[200px] aspect-square rounded-t-xl" />
          <div className="p-4">
            <Skeleton className="h-6 w-36 mb-2" />
            <Skeleton className="h-4 w-48 mb-1" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AssistantLoadingSkeleton;
